/* eslint-disable */
import $api from '@/services/api';
import * as Sentry from '@sentry/browser';

import store from '@/store';

const roleMap = {
  superadmin: 4,
  distributor: 3,
  subdistributor: 2,
  chain: 1,
  store: 0,
};
let initialized = false;

export default {
  user: null,
  init() {
    if (initialized) {
      return Promise.resolve();
    }
    return $api.get('/v1/dashboard/me').then(user => {
      initialized = true;

      this.user = user;
      if (user.prompt_password_reset) {
        store.dispatch('translations/onLabelsLoaded').then(() => {
          const confirmMessage =
            store.getters['translations/getLabel']('RESET_PASSWORD_PROMPT') ||
            'We recommend that you reset your password. Would you like to do this now?XX';
          if (confirm(confirmMessage)) {
            setTimeout(() => {
              window.location.href = '/#/resetpassword';
            });
          }
        });
      }

      if (localStorage.accessId) {
        this.user.selectedAccess = this.user.access.filter(
          access => access.id == localStorage.accessId * 1
        )[0];
      }
      this.user.selectedAccess = this.user.selectedAccess || user.access[0];
      localStorage.accessId = this.user.selectedAccess.id;
      this.user.selectedAccess.roleLevel = roleMap[user.selectedAccess.role];
      Sentry.setUser({ id: user.id, email: user.email });

      $api
        .get(`/v1/dashboard/accessdistributor?id=${localStorage.accessId}`)
        .then(({ access_distributor_id }) => {
          store.dispatch('config/getConfig', {
            distributor_id: access_distributor_id,
          });
          // TODO uncomment for testing Accel
          // store.dispatch('config/getConfig', { distributor_id: 39 });
        });
    });
  },
};
